import {export_months , months, supportTypes } from "./../../services/options.js";

// Generate years from current year down to 2020
const currentYear = new Date().getFullYear();
const years = [];
for (let y = currentYear; y >= 2020; y--) {
    years.push({ text: y });
}
years.push({ value: null, text: " " });

const state = {
    nominatedOpt: [
        { value: 2, text: "Yes" },
        { value: 1, text: "No" },
        { value: null, text: " " },
    ],
    delagatedOpt: [
        { id: 2, text: "Yes" },
        { id: 1, text: "No" },
        { id: null, text: " " },
    ],
    supports: [
        { value: 2, text: "Yes" },
        { value: 1, text: "No" },
        { value: null, text: " " },
    ],
    types: supportTypes,
    months: months,
    export_months :export_months,
    years,
    dotsSupervisionStatus: [
        { value: 1, text: "Stop" },
        { value: 2, text: "On-going" },
    ],
    monthTypes: [
        { value: 1, text: "Month 1" },
        { value: 2, text: "Month 2" },
    ],
    caseFoundAts: [{
            id: 1,
            name: "HE",
            status: 1,
            created_at: null,
            updated_at: null,
        },
        {
            id: 2,
            name: "TBCT",
            status: 1,
            created_at: null,
            updated_at: null,
        },
        {
            id: 3,
            name: "DRTB CT",
            status: 1,
            created_at: null,
            updated_at: null,
        },
        {
            id: 4,
            name: "Community",
            status: 1,
            created_at: null,
            updated_at: null,
        },
        {
            id: 5,
            name: "Follow up",
            status: 1,
            created_at: null,
            updated_at: null,
        },
        {
            id: 6,
            name: "Missing",
            status: 1,
            created_at: null,
            updated_at: null,
        },
        {
            id: 7,
            name: "Screening",
            status: 1,
            created_at: null,
            updated_at: null,
        },
    ],
    InitialOpt: [{ id: 1, text: "M" }],
    relationOpt: [
        { id: 1, text: "Household" },
        { id: 2, text: "Non Household" },
    ],
};
const getters = {};

const mutations = {};

const actions = {};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};